import { SharedApplicationConstants } from '@ddt-web/domain';
import * as isEmpty from 'lodash/isEmpty';

import { ModelRowData } from '../models';

export class MiniCompareUtil {

	public static flattenSelectedModelsDataFromStore(selectedModelsToCompare: any, entities?: any): Array<ModelRowData> {
		const selectedModelsList = selectedModelsToCompare.map((model) => {
			let familyPortfolios = [];
			const familyId = model?.familyId;
			if (entities) {
				familyPortfolios = entities?.[familyId]?.models.filter(row => row?.id === model?.modelId);
				model.checked = true;
			}
			const modelId = model?.rowData?.portfolioId?.toString() || model?.rowData?.id?.toString();
			const isNotBlkGroup = model?.rowData?.groupId !== SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP;
			const modelFamilyExternalNameValue = model?.rowData?.modelFamilyExternalName?.formattedValue;
			const familyDescription = model?.rowData?.familyName?.toString() || entities?.[familyId]?.description;
			const selectedModel = {
				familyId: model?.rowData?.familyId?.toString() || model?.familyId,
				familyName: (isNotBlkGroup && !isEmpty(modelFamilyExternalNameValue)) ? modelFamilyExternalNameValue : familyDescription,
				modelId: modelId || model?.rowData?.modelId || model?.modelId,
				riskProfile: model?.rowData?.riskProfile?.rawValue || model?.rowData?.riskProfile || familyPortfolios?.[0]?.riskProfile,
				modelShortName: model?.rowData?.modelShortName?.toString() || familyPortfolios?.[0]?.shortName,
				checked: model?.checked,
				exploreCardType: model?.rowData?.exploreCardType,
				leftNav: model?.rowData?.leftNav,
				groupId: model?.rowData?.groupId,
				dasPortfolioId: model?.rowData?.dasPortfolioId?.rawValue || model?.rowData?.dasPortfolioId || model?.dasPortfolioId || familyPortfolios?.[0]?.portfolioId
			};
			return selectedModel;
		});
		return selectedModelsList;
	}
}
